import { createContext } from 'react';

export interface UserInfo {
  email: string;
  name: string;
  picture?: string;
}

export interface AuthContextType {
  token: string | null;
  isAuthenticated: boolean;
  /** True when VITE_SKIP_AUTH is enabled (local dev without Google sign-in). */
  authBypassActive: boolean;
  login: (newToken: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
